/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import { extractErrorDetails } from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  loading: false,
  move_train_start_variables: {},
  // trains: {}
});

// State object
const state = initialState();
// Getter functions
const getters = {
  //local state getters
  getMoveTrainStartVariables: (state) => {
    return state.move_train_start_variables;
  },
  isLoading: (state) => state.loading,
  //Getters to Ultra store state
  getTrainLength: (state, getters, rootState, rootGetters) => (train_id) => {
    let max_length_taktarea = 0;
    rootState.Ultra.trains[train_id].taktareas.forEach(taktarea_id => {
      if (rootGetters['TaktArea/getTaktareaLength'](taktarea_id) > max_length_taktarea) {
        max_length_taktarea = rootGetters['TaktArea/getTaktareaLength'](taktarea_id);
      }
    });
    return rootState.Ultra.trains[train_id].train_start + max_length_taktarea;
  },
  getHistTrainLength: (state, getters, rootState, rootGetters) => (train_id) => {
    let max_length_taktarea = 0;
    rootState.Ultra.histtrains[train_id].histtaktareas.forEach(taktarea_id => {
      if (rootGetters['TaktArea/getHistTaktareaLength'](taktarea_id) > max_length_taktarea) {
        max_length_taktarea = rootGetters['TaktArea/getHistTaktareaLength'](taktarea_id);
      }
    });
    return rootState.Ultra.histtrains[train_id].train_start + max_length_taktarea;
  },
  getWorkpackagesInTakt: (state, getters, rootState, rootGetters) => (payload) => {
    //requires Payload: takt_index = Number, trains = Array of Train Ids, colors: Array, status: Array
    let workpackages = [];
    let trains = [];
    let wbgroups = [];
    // create a set milestone_tworkpackages
    let milestone_tworkpackages = new Set();
    if (payload.milestones !== 0) {
      const milestones = rootGetters['Ultra/getUObjects']({ type: 'milestones', ids: payload.milestones });
      milestones.forEach(milestone => {
        milestone.tworkpackages.forEach(tworkpackage => {
          milestone_tworkpackages.add(tworkpackage);
        });
      });
    }
    if (payload.trains.length !== 0) {
      trains = payload.trains;
    } else {
      trains = rootState.Ultra.projects[payload.project_id].trains;
    }
    if (payload.wbgroups && payload.wbgroups.length !== 0) {
      wbgroups = payload.wbgroups;
    } else {
      wbgroups = rootState.Ultra.projects[payload.project_id].wbgroups;
    }
    trains.forEach(train_id => {
      rootState.Ultra.trains[train_id].taktareas.forEach(taktarea_id => {
        let taktarea = rootGetters['TaktArea/getTaktarea'](taktarea_id);
        let waggon_index = payload.takt_index - rootState.Ultra.trains[train_id].train_start - taktarea.taktarea_start;
        if (waggon_index > -1 && waggon_index < taktarea.twaggons.length) {
          let waggon = rootState.Ultra.twaggons[taktarea.twaggons[waggon_index]];
          waggon.tworkpackages.forEach(workpackage_id => {
            let workpackage = JSON.parse(JSON.stringify(rootGetters['TWorkPackage/getTWorkPackage'](workpackage_id)));
            workpackage.taktarea_name = taktarea.name;
            if (
              ( payload.colors.length === 0 || payload.colors.includes(workpackage.color) ) &&
              ( payload.icons.length === 0 || payload.icons.includes(workpackage.icon) ) &&
              ( payload.status.length === 0 || 
                (
                  ( payload.status.includes(workpackage.status) && workpackage.stop_status === 'none' ) ||
                  ( payload.status.includes('stop') && workpackage.stop_status !== 'none' )
                )
              ) &&
              ( milestone_tworkpackages.size === 0 || milestone_tworkpackages.has(workpackage.id) )
            ) {
              workpackages.push(workpackage);
              workpackages[workpackages.length - 1].twaggon = {
                id: waggon.id,
              };
              workpackages[workpackages.length - 1].taktarea = {
                id: taktarea.id,
                name: taktarea.name,
              };
              workpackages[workpackages.length - 1].train = {
                id: train_id,
              };
            }
          });
        }
      });
    });

    wbgroups.forEach(wbgroup_id => {
      rootState.Ultra.wbgroups[wbgroup_id].wblines.forEach(wbline_id => {
        rootState.Ultra.wblines[wbline_id].wbworkpackages.forEach(wbworkpackage_id => {
          let workpackage = JSON.parse(JSON.stringify(rootState.Ultra.wbworkpackages[wbworkpackage_id]));
          // is it in takt?
          let first_wp_takt_index = workpackage.position - 1;
          let last_wp_takt_index = workpackage.position + workpackage.length - 1 - 1;
          if (first_wp_takt_index <= payload.takt_index && payload.takt_index <= last_wp_takt_index) {
            if (
              ( payload.colors.length === 0 || payload.colors.includes(workpackage.color) ) &&
              ( payload.icons.length === 0 || payload.icons.includes(workpackage.icon) ) &&
              ( payload.status.length === 0 || 
                (
                  (payload.status.includes(workpackage.status) && workpackage.stop_status === 'none') ||
                  (payload.status.includes('stop') && workpackage.stop_status !== 'none')
                )
              ) &&
              ( milestone_tworkpackages.size === 0 )
            ) {
              workpackages.push(workpackage);
              workpackages[workpackages.length - 1].wbgroup = {
                id: wbgroup_id
              };
              workpackages[workpackages.length - 1].wbline = {
                id: wbline_id
              };
            }
          }
          // position
          // length
        })
      })
    })



    return workpackages;
  },
  getTWorkPackagesFiltered: (state, getters, rootState, rootGetters) => (payload) => {
    let work_packages = [];
    let trains = [];
    if (payload.trains.length !== 0) {
      trains = payload.trains;
    } else {
      // for(let train_id in rootState.Ultra.trains) {
      //   trains.push(train_id);
      // }
      trains = rootState.Ultra.projects[payload.project_id].trains;
    }
    //trains
    trains.forEach(train_id => {
      //taktareas
      rootState.Ultra.trains[train_id].taktareas.forEach(taktarea_id => {
        let taktarea = rootGetters['TaktArea/getTaktarea'](taktarea_id);
        //twaggons
        taktarea.twaggons.forEach(twaggon_id => {
          let waggon = rootGetters['TWaggon/getTWaggon'](twaggon_id);
          //tworkpackages
          waggon.tworkpackages.forEach(work_package_id => {
            let work_package = rootGetters['TWorkPackage/getTWorkPackage'](work_package_id);
            let push = true;
            for (let prop in payload.filter) {
              if (payload.filter[prop] !== work_package[prop]) {
                push = false;
              }
            }
            if (push) {
              work_packages.push(work_package);
            }
          });
        });
      });
    });
    return work_packages;
  },

  getTrain: (state, getters, rootState) => (train_id) => {
    return rootState.Ultra.trains[train_id];
  },
  getTrains: (state, getters, rootState) => (payload) => {
    if (payload.ids) {
      return payload.ids.map(id => rootState.Ultra.trains[id]);
    } else {
      return Object.keys(rootState.Ultra.trains).map(id => rootState.Ultra.trains[id]);
    }
  },
};
// Actions
const actions = {
  //local train variables
  setMoveTrainStartVariables({ commit }, payload) {
    commit('set_move_train_start_variables', payload);
  },
  //with mutations mutating ultra store
  // trainChangeValue({commit, rootGetters, rootState}, payload) {
  //   let update = {
  //     edit_key: rootGetters['Project/getEditKey']
  //   };
  //   update[payload.value_name] = payload.value;
  //   if (payload.value) {
  //     axios({
  //       url: 'projects/' + payload.project_id +
  //       '/trains/' + payload.train_id,
  //       method: 'PUT',
  //       data: update
  //     })
  //     .then(() => {
  //       commit('train_change_value', {rootState, payload});
  //     })
  //     .catch(err => {
  //       commit('set_error', extractErrorDetails(err));
  //     });
  //   }
  // },
  // setTrainClosed({commit, rootState}, payload) {
  //   commit('set_train_closed', {rootState, payload});
  // },
  // setTrainStart({commit, rootGetters, rootState}, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       url: 'projects/' + payload.project_id +
  //             '/trains/' + payload.train_id,
  //       method: 'PUT',
  //       data: {
  //         train_start: payload.new_train_start,
  //         edit_key: rootGetters['Project/getEditKey'],
  //       }
  //     })
  //     .then(() => {
  //       commit('set_train_start', {rootState, payload});
  //       resolve();
  //     })
  //     .catch(err => {
  //       commit('set_error', extractErrorDetails(err));
  //       reject();
  //     });
  //   });
  // },
  // taktareaChangePosition({commit, rootGetters, rootState}, payload) {
  //   let taktarea_id = rootState.Ultra.trains[payload.train_id].taktareas[payload.drag_evt.oldIndex];
  //   let target_id = rootState.Ultra.trains[payload.train_id].taktareas[payload.drag_evt.newIndex];
  //   axios({
  //     url: 'projects/' + payload.project_id +
  //           '/trains/' + payload.train_id +
  //           '/taktareas/' + taktarea_id +
  //           '/pushpositions',
  //     method: 'PUT',
  //     data: {
  //       taktarea: target_id,
  //       edit_key: rootGetters['Project/getEditKey'],
  //     }
  //   })
  //   .then(() => {
  //     //commit here is too slow -> anzeige bug
  //   })
  //   .catch(err => {
  //     commit('set_error', extractErrorDetails(err));
  //   });
  //   commit('taktarea_change_position', {rootState, payload});
  // },
  // taktareaDelete( { commit, rootGetters, rootState }, payload) {
  // let edit_key = rootGetters['Project/getEditKey'];
  // axios({
  //     url: 'projects/' + payload.project_id +
  //         '/trains/' + payload.train_id +
  //         '/taktareas/' + payload.taktarea_id,
  //     method: 'DELETE',
  //     data: {
  //       edit_key: edit_key,
  //     },
  //   })
  //   .then( () => {
  //     commit('taktarea_delete', {rootState, payload});
  //     commit('TaktArea/taktarea_delete', {rootState, payload}, {
  //       root: true
  //     });
  //     if (payload.taktarea_index-1 !== rootState.Ultra.trains[payload.train_id].taktareas.length -1) {
  //       let update_start_bulk = [];
  //       let difference = rootGetters['TaktArea/getTaktarea'](rootState.Ultra.trains[payload.train_id].taktareas[payload.taktarea_index]).taktarea_start - payload.taktarea_start;
  //       for (let i = payload.taktarea_index; i < rootState.Ultra.trains[payload.train_id].taktareas.length; i++) {
  //         let new_taktarea_start = rootGetters['TaktArea/getTaktarea'](rootState.Ultra.trains[payload.train_id].taktareas[i]).taktarea_start - difference;
  //         update_start_bulk.push({
  //           taktarea_id: rootState.Ultra.trains[payload.train_id].taktareas[i],
  //           new_taktarea_start: new_taktarea_start,
  //         });
  //         axios({
  //           url: 'projects/' + payload.project_id +
  //           '/trains/' + payload.train_id +
  //           '/taktareas/' + rootState.Ultra.trains[payload.train_id].taktareas[i],
  //           method: 'PUT',
  //           data: {
  //             taktarea_start: new_taktarea_start,
  //             edit_key: edit_key,
  //           }
  //         });
  //       }
  //       commit('TaktArea/set_taktarea_start_bulk', {rootState, payload: {data: update_start_bulk}},{root: true});
  //     }
  //   })
  //   .catch(err => {
  //     commit('set_error', extractErrorDetails(err));
  //   });
  // },
  taktareaInsert({ commit, rootGetters, rootState }, payload) {
    let taktareas = [];
    let edit_key = rootGetters['Project/getEditKey'];
    for (let i = 0; i < payload.count; i++) {
      taktareas.push({
        taktarea_start: payload.taktarea_start + payload.direction + i,
        position: payload.taktarea_position + payload.direction + i,
      });
    }
    axios({
      url: 'projects/' + payload.project_id +
        '/trains/' + payload.train_id +
        '/taktareas/copytaktareabulk',
      method: 'POST',
      data: {
        edit_key: edit_key,
        taktarea_copy: payload.taktarea_id,
        taktareas: taktareas
      }
    })
      .then((resp) => {
        commit('taktareas_insert_bulk', {
          rootState, payload: {
            train_id: payload.train_id,
            taktareas: resp.data.data.taktareas
          }
        });
        commit('TaktArea/taktareas_insert_bulk', { rootState, payload: resp.data.data.taktareas },
          { root: true }
        );
        commit('TWaggon/twaggons_insert_bulk', { rootState, payload: resp.data.data.twaggons },
          { root: true }
        );
        commit('TWorkPackage/twork_packages_insert_bulk', { rootState, payload: resp.data.data.twork_packages },
          { root: true }
        );
        if (payload.taktarea_position + payload.direction - 1 !== rootState.Ultra.trains[payload.train_id].taktareas.length - payload.count) {
          let update_start_bulk = [];
          for (let i = payload.taktarea_position + payload.count + payload.direction - 1; i < rootState.Ultra.trains[payload.train_id].taktareas.length; i++) {
            let new_taktarea_start = rootGetters['TaktArea/getTaktarea'](rootState.Ultra.trains[payload.train_id].taktareas[i]).taktarea_start + payload.count;
            update_start_bulk.push({
              taktarea_id: rootState.Ultra.trains[payload.train_id].taktareas[i],
              new_taktarea_start: new_taktarea_start,
            });
            axios({
              url: 'projects/' + payload.project_id +
                '/trains/' + payload.train_id +
                '/taktareas/' + rootState.Ultra.trains[payload.train_id].taktareas[i],
              method: 'PUT',
              data: {
                taktarea_start: new_taktarea_start,
                edit_key: edit_key,
              }
            });
          }
          commit('TaktArea/set_taktarea_start_bulk', { rootState, payload: { data: update_start_bulk } }, { root: true });
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
  },
};
// Mutations
const mutations = {
  //local state mutation
  set_move_train_start_variables(state, payload) {
    state.move_train_start_variables = Object.assign(state.move_train_start_variables, payload);
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  train_loading(state, loading) {
    state.loading = loading;
  },
  set_error(state, err) {
    state.error = err;
  },
  //ultra store state mutation
  // train_change_value(state, {rootState, payload}) {
  //   Vue.set(rootState.Ultra.trains[payload.train_id],`${payload.value_name}`, payload.value);
  // },
  // set_train_closed(state, {rootState, payload}) {
  //   Vue.set(rootState.Ultra.trains[payload.train_id], 'closed', payload.value);
  // },
  // set_train_start(state, {rootState, payload}) {
  //   Vue.set(rootState.Ultra.trains[payload.train_id], 'train_start', payload.new_train_start);
  // },
  taktarea_change_position(state, { rootState, payload }) {
    let taktareas = rootState.Ultra.trains[payload.train_id].taktareas;
    taktareas.splice(payload.drag_evt.newIndex, 0, taktareas.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  taktarea_delete(state, { rootState, payload }) {
    rootState.Ultra.trains[payload.train_id].taktareas.splice(payload.taktarea_index, 1);
  },
  taktareas_insert_bulk(state, { rootState, payload }) {
    for (let taktarea_id in payload.taktareas) {
      rootState.Ultra.trains[payload.train_id].taktareas.splice(payload.taktareas[taktarea_id].position - 1, 0, parseInt(taktarea_id));
    }
  },
  train_delete(state, { rootState, payload }) {
    Vue.delete(rootState.Ultra.trains, payload.train_id);
  },
  trains_insert_bulk(state, { rootState, payload }) {
    Vue.set(rootState.Ultra, 'trains', Object.assign({}, rootState.Ultra.trains, payload));
  },
  trains_success(state, { rootState, payload }) {
    Vue.set(rootState.Ultra, 'trains', Object.assign({}, rootState.Ultra.trains, payload));
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
